import React from "react";
import {
  Container,
  Flex,
  Box,
  Heading,
  Text,
  Link,
} from "@chakra-ui/react";

import Footer from "../components/footer";
//import Customerservicebot from "./customerservicesbot";

export default function TermsofService() {
  return (
    <>
      {/* <Customerservicebot /> */}
      <Box>
        <Container maxW="full" mt={0} centerContent overflow="hidden">
          <Flex>
            <Box maxW="1500px" mx="auto" px={4} mt={10} style={{marginLeft:"20px",marginRight:"20px"}}>
              <Heading as="h3" style={{ margin: "20px", textAlign: "center", color: "#3A56D4" }}>
                Privacy Policy
              </Heading>

              <Text mb={4} style={{marginLeft:"20px",marginRight:"20px"}}>
                Privacy Policy for Unlimiteye Solutions Pvt. Ltd. - AI powered 
                Design ,development and recruitment
              </Text>

              {/* Effective Date */}
              <Text style={{marginLeft:"20px",marginRight:"20px"}} mb={4}>
                Effective Date: 01/01/2024
              </Text>

              {/* Introduction */}
              <Text style={{marginLeft:"20px",marginRight:"20px"}} mb={4}>
                Unlimiteye Solutions Pvt. Ltd. ("we," "our," or "us") is
                committed to protecting the privacy of our users, including job
                seekers and recruiters. This Privacy Policy outlines our
                practices regarding the collection, use, and disclosure of
                personal information through our digital recruitment platform.
              </Text>

              {/* Section 1: Information We Collect */}
              <Heading as="h4" style={{fontSize:"18px"}} mb={4}>
                1. Information We Collect
              </Heading>
              <Text>
                <strong style={{marginLeft:"20px",marginRight:"20px"}}>
                    a. Personal Information:
                </strong>
                <br />
                <strong style={{marginLeft:"30px",marginRight:"30px"}}>
                    Job Seekers:
                </strong>
                <ul style={{marginLeft:"50px",marginRight:"50px"}}>
                  <li>Name</li>
                  <li>Email</li>
                  <li>Contact Number</li>
                  <li>Current Photo</li>
                  <li>Valid ID proof</li>
                  <li>Resume and professional qualifications</li>
                </ul>
                <strong style={{marginLeft:"30px",marginRight:"30px"}}>Recruiters:</strong>
                <ul style={{marginLeft:"50px",marginRight:"50px",marginBottom:"10px"}}>
                  <li>Name</li>
                  <li>Email</li>
                  <li>Contact Number</li>
                </ul>
                <strong style={{marginLeft:"20px",marginRight:"20px"}}>b. Job-related Information:</strong>
                <ul style={{marginLeft:"50px",marginRight:"50px",marginBottom:"10px"}}>
                  <li>
                    <strong>Candidates:</strong>
                    <ul>
                      <li>Job requirements</li>
                      <li>Responses to questions asked during the recruitment process</li>
                    </ul>
                  </li>
                  <li>
                    <strong>Recruiters:</strong>
                    <ul>
                      <li>Questions posed to candidates</li>
                      <li>Answers received from candidates</li>
                    </ul>
                  </li>
                </ul>
              </Text>

              {/* Section 2: How We Use Your Information */}
              <Heading as="h4" style={{fontSize:"18px"}} mb={4}>
                2. How We Use Your Information
              </Heading>
              <Text style={{marginLeft:"20px",marginRight:"20px",marginBottom:"10px"}}>
                We use the collected information for the following purposes:
                <ul style={{marginLeft:"30px",marginRight:"30px"}}>
                  <li>Facilitating communication between job seekers and recruiters.</li>
                  <li>Assessing candidate suitability for job positions.</li>
                  <li>Improving and enhancing our recruitment platform.</li>
                  <li>Complying with legal and regulatory requirements.</li>
                  <li>Notifying users about relevant job opportunities and updates.</li>
                </ul>
              </Text>

              {/* Section 3: Data Security */}
              <Heading as="h4" style={{fontSize:"18px"}} mb={4}>
                3. Data Security
              </Heading>
              <Text style={{marginLeft:"20px",marginRight:"20px",marginBottom:"10px"}}>
                We are committed to ensuring the security, integrity, and
                confidentiality of your information. We implement
                industry-standard security measures to protect your data from
                unauthorized access, disclosure, alteration, and destruction.
              </Text>

              {/* Section 4: Data Access and Sharing */}
              <Heading as="h4" style={{fontSize:"18px"}} mb={4}>
                4. Data Access and Sharing
              </Heading>
              <Text style={{marginLeft:"20px",marginRight:"20px",marginBottom:"10px"}}>
                We do not sell, trade, or rent your personal information to
                third parties. Access to personal information is restricted to
                our authorized personnel and is used only for the purposes
                outlined in this Privacy Policy.
              </Text>

              {/* Section 5: Consent */}
              <Heading as="h4" style={{fontSize:"18px"}} mb={4}>
                5. Consent
              </Heading>
              <Text style={{marginLeft:"20px",marginRight:"20px",marginBottom:"10px"}}>
                By using our digital recruitment platform, you consent to the
                collection, use, and disclosure of your information as described
                in this Privacy Policy.
              </Text>

              {/* Section 6: Retention Period */}
              <Heading as="h4" style={{fontSize:"18px"}} mb={4}>
                6. Retention Period
              </Heading>
              <Text style={{marginLeft:"20px",marginRight:"20px",marginBottom:"10px"}}>
                We retain your personal information for as long as necessary to
                fulfill the purposes outlined in this Privacy Policy unless a
                longer retention period is required or permitted by law.
              </Text>

              {/* Section 7: Your Rights */}
              <Heading as="h4" style={{fontSize:"18px"}} mb={4}>
                7. Your Rights
              </Heading>
              <Text style={{marginLeft:"20px",marginRight:"20px",marginBottom:"10px"}}>
                You have the right to access, correct, or delete your personal
                information. If you have any questions or concerns about your
                data, please contact us using the information provided at the
                end of this policy.
              </Text>

              {/* Section 8: Changes to Privacy Policy */}
              <Heading as="h4" style={{fontSize:"18px"}} mb={4}>
                8. Changes to Privacy Policy
              </Heading>
              <Text style={{marginLeft:"20px",marginRight:"20px",marginBottom:"10px"}}>
                We reserve the right to update this Privacy Policy to reflect
                changes in our practices. Users will be notified of any
                significant changes via email or through our platform.
              </Text>

              {/* Section 9: Contact Information */}
              <Heading as="h4" style={{fontSize:"18px"}} mb={4}>
                9. Contact Information
              </Heading>
              <Text style={{marginLeft:"20px",marginRight:"20px",marginBottom:"10px"}}>
                If you have any questions about our Privacy Policy, please
                contact us at:
                <br />
                Unlimiteye Solutions Pvt. Ltd.
                <br />
                <br/>
                <b>Email:</b> 
                <Link 
                  href="mailto:contactus@unlimiteye.com" 
                  style={{color:"#3B58D7",textDecoration:"underline",marginLeft:"10px"}}
                >
                  contactus@unlimiteye.com
                </Link> , {" "}
                <Link 
                  href="mailto:aptofycare@unlimiteye.com" 
                  style={{color:"#3B58D7",textDecoration:"underline"}}
                  >
                    aptofycare@unlimiteye.com
                </Link>
                <br />
                <b>Website:</b>
                  <Link 
                    href="https://www.unlimiteye.com" 
                    style={{color:"#3B58D7",textDecoration:"underline",marginLeft:"10px"}}
                  >
                    www.unlimiteye.com
                  </Link> , {" "}
                <Link
                    href="https://www.aptofy.com" 
                    style={{color:"#3B58D7",textDecoration:"underline"}}
                  >
                    www.aptofy.com
                  </Link>
              </Text>

              {/* Thank You Message */}
              <Text style={{marginLeft:"20px",marginRight:"20px",marginBottom:"10px"}} mt={6}>
                Thank you for trusting us with your personal information. We are
                dedicated to maintaining the privacy and security of your data.
              </Text>

            </Box>
          </Flex>
        </Container>
        <Footer />
      </Box>
    </>
  );
}
